<template>
  <div class="h-full min-h-screen flex flex-col bg-slate-50 overflow-hidden">
    <template v-if="showShell">
      <header class="h-16 flex items-center justify-between px-4 md:px-6 bg-[#0d4169] text-white border-b border-white/10 shadow-md shrink-0">
        <div class="flex items-center gap-3">
          <!-- <img src="./assets/logo.png" alt="Aftalink" class="h-9 w-auto object-contain brightness-0 invert" /> -->
          <div>
            <h1 class="text-sm font-black leading-tight">AFTALINK JOBS</h1>
            <p class="text-[10px] text-white/70 font-semibold">Admin Panel</p>
          </div>
        </div>
        <div class="flex items-center gap-3">
          <button
            type="button"
            class="hidden sm:inline-flex text-xs font-bold px-3 py-1.5 rounded-lg bg-white/10 border border-white/20 hover:bg-white/20 transition"
            :class="route.name === 'dashboard' ? 'bg-white/20' : ''"
            @click="$router.push({ name: 'dashboard' })"
          >
            Dashboard
          </button>
          <button
            type="button"
            class="hidden sm:inline-flex text-xs font-bold px-3 py-1.5 rounded-lg bg-white/10 border border-white/20 hover:bg-white/20 transition"
            :class="route.name === 'jobs' || route.name === 'job_review' ? 'bg-white/20' : ''"
            @click="$router.push({ name: 'jobs' })"
          >
            Jobs
          </button>
          <button
            type="button"
            class="text-xs font-bold px-3 py-1.5 rounded-lg bg-rose-500/20 border border-white/20 hover:bg-rose-500/30 transition"
            @click="logout"
          >
            Logout
          </button>
        </div>
      </header>

      <nav class="sm:hidden shrink-0 grid grid-cols-2 gap-1 bg-white border-b border-slate-200 px-2 py-2">
        <button
          type="button"
          class="py-2 rounded-lg text-xs font-bold"
          :class="route.name === 'dashboard' ? 'bg-[#e9f2f8] text-[#0d4169]' : 'text-slate-500'"
          @click="$router.push({ name: 'dashboard' })"
        >
          Dashboard
        </button>
        <button
          type="button"
          class="py-2 rounded-lg text-xs font-bold"
          :class="route.name === 'jobs' || route.name === 'job_review' ? 'bg-[#e9f2f8] text-[#0d4169]' : 'text-slate-500'"
          @click="$router.push({ name: 'jobs' })"
        >
          Jobs
        </button>
      </nav>
    </template>

    <main class="flex-1 overflow-y-auto">
      <router-view />
    </main>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default {
  name: 'App',
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const showShell = computed(() => route.name !== 'login' && store.getters.isAuthenticated)

    async function logout() {
      await store.dispatch('logout')
      router.push({ name: 'login' })
    }

    return { showShell, route, logout }
  },
}
</script>
